const fr: Record<string, string> = {
  'features.events.addEvent': 'Ajouter un événement',
  'features.events.create': 'Créer',
  'features.events.editEvent': 'Modifier l\'événement',
  'features.events.viewEvent': 'Événement',
  'features.events.openInProject': 'Ouvrir dans le projet',
  'features.events.title': 'Titre',
  'features.events.titlePlaceholder': 'Titre de l\'événement...',
  'features.events.schedule': 'Date et heure',
  'features.events.allDay': 'Toute la journée',
  'features.events.multiDay': 'Plusieurs jours',
  'features.events.from': 'De',
  'features.events.to': 'À',
  'features.events.participants': 'Participants',
  'features.events.labels': 'Étiquettes',
  'features.events.color': 'Couleur',
  'features.events.storyPoints': 'Points d\'effort',
  'features.events.notes': 'Notes',
  'features.events.noNotes': 'Pas encore de notes.',
  'features.events.reminders': 'Rappels',
  'features.events.addReminder': 'Ajouter un rappel',
  'features.events.reminderNotification': 'Notification',
  'features.events.reminderMail': 'Email',
  'features.events.delete': 'Supprimer',
  'features.events.confirmDelete': 'Confirmer la suppression',
  'features.events.during': 'pendant',
  'features.events.duration': 'Durée',
  'features.events.durationDays': '{{days}} jour(s) et {{hours}} heure(s)',
  'features.events.midnight': 'Minuit',
  'features.events.noEvents': 'Aucun événement ce jour.',
  'features.events.noEventsWeek': 'Aucun événement cette semaine.',
  'features.events.switchToWeekView': 'Passer à la vue semaine',
  'features.events.switchToDayView': 'Passer à la vue jour',
};

export default fr;
